module.exports = __webpack_public_path__ + "static/media/sidebar-1fa66a345935416aca946585200630599jpg";